var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v(" Создание подразделения "), _c('div', {
    staticClass: "ml-5"
  }, [_c('v-btn', {
    staticClass: "mx-4",
    attrs: {
      "small": "",
      "color": "primary",
      "outlined": "",
      "to": "/subdivisions"
    }
  }, [_vm._v("Все подразедления")])], 1)]), _c('SubdivisionForm')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }